<template>
  <SiteSearch360
    site-id="statecs.am_1"
    :ss360-config="ss360Config"
  />
</template>

<script>
import SiteSearch360 from 'site-search-360-vue';

export default {
  name: 'GlobalSearch',
  components: {
    SiteSearch360,
  },
  data() {
    return {
      ss360Config: {
        searchBox: {
          placeholder: 'Search',
        },
      },
    };
  },
};
</script>
